export const STOCKTAKING_LIST_TAB = {
  field: 'preset',
  isPreset: true,
  defaultTab: 'all',
  tabs: [
    { key: 'all', label: 'All', preset: {} },
    {
      key: 'in_progress',
      label: 'In Progress',
      preset: { status: 'in_progress' },
    },
    { key: 'adjusted', label: 'Adjusted', preset: { status: 'adjusted' } },
    { key: 'completed', label: 'Completed', preset: { status: 'completed' } },
    { key: 'aborted', label: 'Aborted', preset: { status: 'aborted' } },
  ],
};
